import _ from 'lodash';

import {safeGet, safeSet} from 'ub/utils';
import pomUpdates from 'ub_legacy/lp/pom/updates/updates';

const checkVersion = (pomData, minVersion, newVersion) => {
  const current = pomData.version || '0';

  if (current >= newVersion) {
    return false;
  }

  if (current < minVersion) {
    throw new Error(`Page version ${current} can't be updated to version ${newVersion}`);
  }
  return true;
};

pomUpdates.add({
  minVersion: '2.9',
  version: '3.0',

  run: function(pomData0) {
    if (!checkVersion(pomData0.mainPage, this.minVersion, this.version)) {
      return pomData0;
    }

    const pomData = _.cloneDeep(pomData0);
    const DEFAULT_COLUMN_DIVISOR = 100;

    const updateElement = (el) => {
      if (el.type === 'lp-pom-form') {
        if (!safeGet(el, 'geometry.field.groupWidth')) {
          safeSet(el, 'geometry.field.groupWidth', DEFAULT_COLUMN_DIVISOR);
        }
      }
    };

    [pomData.mainPage, ...pomData.subPages].forEach((page) => {
      page.elements.forEach(updateElement);
      page.version = this.version;
    });

    return pomData;
  }
});



// WEBPACK FOOTER //
// ./src/updaters/3.0.js